import { CheckCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";

import type { ContentType, } from "./dailyCheckInTypes"

export default function createContentColumns(
  dateFilters: any,
  handleEdit: (record: ContentType) => void,
): ColumnsType<ContentType> {
  return [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      filters: dateFilters,
      onFilter: (value, record) => record.monthText === value,
      render: (_, record) => {
        const day = Number(record.monthDay.split('-')[1])

        return (
          <>
            {record.monthText} {day}
          </>
        )
      },
    },
    {
      title: 'Theme slot · name',
      key: 'themeSlotName',
      render: (_, record) => (
        <>
          {record.themeSlot} · {record.themeName}
        </>
      ),
    },
    {
      title: 'Expression text',
      dataIndex: 'expressionText',
      key: 'expressionText',
    },
    {
      title: 'Theme name',
      dataIndex: 'themeName',
      key: 'themeName',
    },
    {
      title: 'Audio',
      dataIndex: 'isExpressionAudioDone',
      key: 'isExpressionAudioDone',
      width: 100,
      sorter: (a, b) => Number(a.isExpressionAudioDone) - Number(b.isExpressionAudioDone),
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : null;
      },
    },
    {
      title: 'Image',
      dataIndex: 'isExpressionImageDone',
      key: 'isExpressionImageDone',
      width: 100,
      sorter: (a, b) => Number(a.isExpressionImageDone) - Number(b.isExpressionImageDone),
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : null;
      },
    },
    {
      title: 'Correct audio',
      dataIndex: 'isCorrectAudioDone',
      key: 'isCorrectAudioDone',
      width: 100,
      sorter: (a, b) => Number(a.isCorrectAudioDone) - Number(b.isCorrectAudioDone),
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : null;
      },
    },
    {
      title: 'Correct img',
      dataIndex: 'isCorrectImageDone',
      key: 'isCorrectImageDone',
      width: 100,
      sorter: (a, b) => Number(a.isCorrectImageDone) - Number(b.isCorrectImageDone),
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : null;
      },
    },
    {
      title: 'Incorrect img',
      dataIndex: 'isIncorrectImageDone',
      key: 'isIncorrectImageDone',
      width: 100,
      sorter: (a, b) => Number(a.isIncorrectImageDone) - Number(b.isIncorrectImageDone),
      render: (value) => {
        return value ? (
          <span>
            Done
            <CheckCircleFilled className="done-icon" />
          </span >
        ) : null;
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: 100,
      render: (_, record) => (
        <Button type="link" className="w-9 p-0" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];
}